import React, { Component } from "react"
import { Icon, Button } from 'semantic-ui-react'
import { COLORS } from 'Constants'
import HeaderBar from 'screens/HeaderBar'
import { translate } from 'react-i18next'

class ErrorPage extends Component {
  constructor(props) {
    super(props);

    this.state={
      showDetails: false
    };
  }

  render() {
    const { t } = this.props;
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          textAlign: "center",
          bottom: 0,
          left: 0,
          margin: "auto",
          position: "absolute",
          right: 0,
          top: 0,
          backgroundColor: COLORS.POLY_WHITE
        }}
      >
        <HeaderBar {...this.props}/>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "inline-block",
            textAlign: "center",
            margin: "auto",
            marginTop: "10%",
          }}
        >
          <div 
            style={{
            width: "35%",
            display: "inline-block",
            textAlign: "left",
            color: COLORS.POLY_BLACK,
          }}
          >
            <h2>Server Error</h2>
            <div style={{
              width: "100%",
              display: "inline-block",
              borderRadius: "25px",
              background: COLORS.POLY_MIDNIGHT,
              padding: "30px",
              color: COLORS.POLY_LAVA,
              textAlign: "center"
            }}
            >
              <div><Icon className="polycom warning sign massive"/></div>
              <p style={{color: COLORS.POLY_WHITE}}>{t("Error.p1")}</p>
              <p style={{color: COLORS.POLY_WHITE}}>{t("Error.p2")}</p>
              <Button onClick={()=>{
                this.setState({showDetails:!this.state.showDetails});
              }}>Details</Button>
              
            </div>
              { this.state.showDetails &&
                <pre style={{color: COLORS.POLY_BLACK,textAlign: "left"}}>{JSON.stringify(this.props.error, undefined, 2)}</pre>
              }
          </div>
        </div>
      </div>
    );
  }
}

export default translate()(ErrorPage);
